import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileForbiddenFill.tsx
const IconFileForbiddenFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 48 48",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M40 3.984V22H24a4 4 0 0 0-3.935 3.278c-.086.472.021.952.19 1.401L26 42H5.987a1.98 1.98 0 0 1-1.446-.632A2.02 2.02 0 0 1 4 39.987V14L16.006 2h21.99C39.103 2 40 2.91 40 3.984M18 5 7 16h11z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("rect", {
			width: 8,
			height: 4,
			x: 32,
			y: 42,
			fill: "currentColor",
			rx: 2
		}),
		/* @__PURE__ */ jsx("rect", {
			width: 16,
			height: 4,
			x: 28,
			y: 34,
			fill: "currentColor",
			rx: 2
		}),
		/* @__PURE__ */ jsx("rect", {
			width: 24,
			height: 4,
			x: 24,
			y: 26,
			fill: "currentColor",
			rx: 2
		})
	]
});
var IconFileForbiddenFill_default = forwardRef(IconFileForbiddenFill);
//#endregion
export { IconFileForbiddenFill_default as default };
